import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import type { Dispatch, Action } from "redux";
import ClonePageFd from "../../components/ClonePageFd";
import { closeClonePageDialog, startClonePage } from "../../actions/pageActions";
import { getHashValue } from "../../services/jusCan";
import { getIsPageCloningOpen, getCloningSelectedPage } from "../../selectors/pageActions";
import { getIsClonePageLoading } from "../../selectors/loading";
import type { State } from "../../pages/AppStoreWrapper";
import type { StateToProps, DispatchToProps, Props } from "./types/ClonePageDialog.type";

const mapStateToProps: (state: State) => StateToProps = (state) => ({
  isOpen: getIsPageCloningOpen(state),
  selectedPage: getCloningSelectedPage(state),
  loading: getIsClonePageLoading(state),
});

const mapDispatchToProps: (arg0: Dispatch<any>) => DispatchToProps = dispatch => ({
  ...bindActionCreators({
    startClone: startClonePage,
    closeDialog: closeClonePageDialog,
  }, dispatch),
});

function ClonePageDialog({
  isOpen,
  selectedPage,
  startClone,
  closeDialog,
  loading,
}: Props) {
  const mainAccountId = getHashValue();

  return (
    <ClonePageFd
      open={isOpen}
      page={selectedPage}
      mainAccountId={mainAccountId}
      onApply={startClone}
      onClose={closeDialog}
      loading={loading}
    />
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ClonePageDialog);
